import { Form, Radio } from 'antd';
import React, { ReactElement } from 'react';

interface Props {
  index: number;
  value?: string;
}

export function FieldExchangeNumbers(props: Props): ReactElement | null {
  const { index, value } = props;
  const exchangeOptions = [
    { label: 'Yes', value: 'YES' },
    { label: 'No', value: 'NO' },
  ];

  return (
    <Form.Item name={`exchangeNumbers${index}`} label="Exchanged numbers">
      <Radio.Group options={exchangeOptions} value={value} />
    </Form.Item>
  );
}
